import { Component, OnInit, ViewChild, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { MediaMatcher } from '@angular/cdk/layout';
import { CdkAccordionItem } from '@angular/cdk/accordion';
import { IBtn } from 'src/app/custom-components/interfaces/btn.interface';
import { Color } from 'src/app/utils/color.enum';
import { SessionService } from 'src/app/services/session.service';


@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit, OnDestroy {

  @ViewChild(MatSidenav) sidenav: MatSidenav;

  mobileQuery: MediaQueryList;
  private mobileQueryListener: () => void;
  public isOpen: boolean;
  step = 0;
  menuList = [];
  modulo: any = '/';



  btns: Array<IBtn> = [
    {
      texto: 'Nuevo registro',
      color: Color.PRIMARY,
      tipo: 'raised',
      key: 'registrar',
      tooltip: 'Registrar nueva persona'
    }
  ];

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public sessionService: SessionService
  ) {
    this.menuList = this.getMenu();
    // setTimeout( () => {
    //   console.log(this.menuList);
    //   this.menuList[1].menu.push({
    //     id: 121,
    //     nombre: 'Transacciones R',
    //     permisos: ['V'],
    //     url: '/reporte/transacciones',
    //     icono: 'send'
    //   });
    // }, 800);
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this.mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addEventListener('change', this.mobileQueryListener);
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeEventListener('change', this.mobileQueryListener);
  }

  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  getMenu() {
    this.modulo = this.modulo + this.sessionService.getModulo();
    return this.menuList = this.sessionService.getMenuList()[0].menu;
  }
}
